/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
/* Mostrar SKU en el buscador predictivo */
(function () {
  try {
    var cache = {};
    function skuFor(handle) {
      if (cache[handle]) return cache[handle];
      return (cache[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var s = (p.variants || []).map(function (v) { return v.sku; }).filter(Boolean);
          if (!s.length) return '';
          return s.length === 1 ? s[0] : s[0] + ' (+' + (s.length - 1) + ' más)';
        })
        .catch(function () { return ''; }));
    }
    function decorate(root) {
      root.querySelectorAll('a.search-bar__result-item:not(.search-bar__result-item--skeleton)').forEach(function (a) {
        if (a.dataset.skuDone) return;
        a.dataset.skuDone = '1';
        var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
        if (!m) return;
        skuFor(m[1]).then(function (sku) {
          if (!sku) return;
          var info = a.querySelector('.search-bar__item-info');
          if (!info) return;
          var el = document.createElement('span');
          el.className = 'search-bar__item-sku';
          el.textContent = 'SKU: ' + sku;
          el.style.cssText = 'display:block;font-size:12px;font-weight:600;letter-spacing:.02em;opacity:.75;margin-top:2px';
          var title = info.querySelector('.search-bar__item-title');
          (title || info).insertAdjacentElement(title ? 'afterend' : 'beforeend', el);
        });
      });
    }
    function init() {
      document.querySelectorAll('.search-bar__results').forEach(function (box) {
        if (box.dataset.skuObs) return;
        box.dataset.skuObs = '1';
        new MutationObserver(function () { decorate(box); }).observe(box, { childList: true, subtree: true });
        decorate(box);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  } catch (e) {}
})();
/* AROL Fase 5 · Datos y ayuda por variante. No modifica precios ni búsqueda. */
(function () {
  function update(box, variant) {
    if (!variant) return;
    var sku = variant.sku || '', title = variant.title === 'Default Title' ? '' : (variant.title || '');
    box.dataset.variantId = variant.id;
    box.querySelector('[data-arol-consultation-variant]').textContent = title;
    box.querySelector('[data-arol-consultation-variant-row]').hidden = !title;

  }
  // Tablas o listas de definición existentes en la descripción: copiar solo rótulos exactos.
  function existingDescriptionFields(box) {
    var section = box.closest('[data-section-type="product"]'), script = section && section.querySelector('[data-product-json]');
    if (!script) return;
    var product;try { product = JSON.parse(script.textContent).product; } catch (error) { return; }
    var doc = new DOMParser().parseFromString(product.description || '', 'text/html'), fields = {};
    function field(label, value) {
      label = label.trim().replace(/:$/, '').trim().toLowerCase();value = value.trim();
      if ((label === 'marca' || label === 'modelo') && value && !fields[label]) fields[label] = value;
    }
    doc.querySelectorAll('tr').forEach(function (row) {
      var cells = Array.from(row.children).filter(function (cell) { return cell.tagName === 'TD' || cell.tagName === 'TH'; });
      if (cells.length === 2) field(cells[0].textContent, cells[1].textContent);
    });
    doc.querySelectorAll('dt').forEach(function (dt) { var dd = dt.nextElementSibling;if (dd && dd.tagName === 'DD') field(dt.textContent, dd.textContent); });
    [['modelo', 'model', 'Modelo (producto)'], ['marca', 'brand', 'Marca']].forEach(function (entry) {
      if (!fields[entry[0]] || box.querySelector('[data-arol-consultation-' + entry[1] + ']')) return;
      var row = document.createElement('div'), label = document.createElement('dt'), value = document.createElement('dd');
      label.textContent = entry[2];value.textContent = fields[entry[0]];value.setAttribute('data-arol-consultation-' + entry[1], '');
      value.dataset.source = 'description';row.append(label, value);box.querySelector('dl').appendChild(row);
    });
  }
  function initialize(root) { root.querySelectorAll('[data-arol-consultation]').forEach(existingDescriptionFields); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); });else initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  document.addEventListener('variant:changed', function (event) {
    var section = event.target.closest && event.target.closest('[data-section-type="product"]');
    if (!section) return;
    section.querySelectorAll('[data-arol-consultation]').forEach(function (box) { update(box, event.detail && event.detail.variant); });
    var variant = event.detail && event.detail.variant;
    if (variant) section.querySelectorAll('[data-arol-sku-control]').forEach(function (box) {
      box.querySelector('[data-arol-sku-value]').textContent = variant.sku || '';
      box.hidden = !variant.sku;var status = box.querySelector('[data-arol-copy-status]');clearTimeout(status._arolCopyTimer);status.classList.remove('is-visible');status.textContent = '';
    });
  });
  function showCopyNotice(status, text, duration) {
    clearTimeout(status._arolCopyTimer);status.textContent = text;status.classList.add('is-visible');
    status._arolCopyTimer = setTimeout(function () { status.classList.remove('is-visible'); }, duration);
  }
  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-arol-copy-sku]');
    if (!button) return;
    var box = button.closest('[data-arol-sku-control]'), text = box.querySelector('[data-arol-sku-value]').textContent.trim();
    if (!text) return;
    var status = box.querySelector('[data-arol-copy-status]');
    try {
      if (navigator.clipboard && window.isSecureContext) await navigator.clipboard.writeText(text);
      else throw new Error('Clipboard unavailable');
      showCopyNotice(status, 'SKU copiado', 1500);
    } catch (error) {
      // Selección manual: no afirmar que se copió si el navegador deniega el portapapeles.
      var range = document.createRange();range.selectNodeContents(box.querySelector('[data-arol-sku-value]'));
      var selection = window.getSelection();selection.removeAllRanges();selection.addRange(range);
      showCopyNotice(status, 'SKU seleccionado. Mantén pulsado para copiarlo.', 3000);
    }
  });
})();

/* Ajustes Fase 5A · Normalizar únicamente una clave completa de cuatro letras + tres dígitos. */
(function () {
  function normalized(value) {
    var match = value.trim().match(/^([a-z]{4})[\s-]+(\d{3})$/i);
    return match ? match[1].toUpperCase() + match[2] : value;
  }
  function searchForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    try { var url = new URL(form.action, location.href);return url.origin === location.origin && /^\/search\/?$/.test(url.pathname); } catch (error) { return false; }
  }
  // Captura antes del listener del tema: las sugerencias y el envío usan la misma clave.
  document.addEventListener('input', function (event) {
    var input = event.target;
    if (event.isComposing || !input.matches('input[name="q"]') || !searchForm(input.form)) return;
    var value = normalized(input.value);if (value !== input.value) input.value = value;
  }, true);
  document.addEventListener('submit', function (event) {
    if (!searchForm(event.target)) return;
    var input = event.target.querySelector('input[name="q"]');if (input) input.value = normalized(input.value);
  }, true);
  // También funciona al abrir una URL de búsqueda ya escrita, conservando todos sus otros parámetros.
  if (/^\/search\/?$/.test(location.pathname)) {
    var url = new URL(location.href), query = url.searchParams.get('q');
    if (query !== null && normalized(query) !== query) { url.searchParams.set('q', normalized(query));location.replace(url.href); }
  }
})();

/* AROL 5D · listas largas de filtros: presentación, sin modificar motor ni valores. */
(function () {
  var serial = 0;
  function initialize(root) {
    root.querySelectorAll('.collection__filter-checkbox-list,.collection__filter-group-list,.collection__filter-color-list .color-swatch-list').forEach(function (list) {
      if (list.dataset.arolFilterLimited) return;
      var entries = Array.from(list.children).filter(function (e) { return e.matches('.collection__filter-checkbox,.collection__filter-group,.color-swatch'); });
      if (entries.length <= 15) return;
      entries.sort(function (a,b) { return (parseInt(getComputedStyle(a).order,10)||0)-(parseInt(getComputedStyle(b).order,10)||0); });
      list.dataset.arolFilterLimited = 'true';if (!list.id) list.id = 'arol-filter-list-' + (++serial);
      var extras = entries.slice(8);extras.forEach(function (e) { e.classList.add('arol-filter-extra');e.hidden = true; });
      var button = document.createElement('button');button.type = 'button';button.className = 'arol-filter-more';button.textContent = 'Ver más';button.setAttribute('aria-expanded','false');button.setAttribute('aria-controls',list.id);
      button.addEventListener('click',function () {
        var open = button.getAttribute('aria-expanded') !== 'true';extras.forEach(function (e) { e.hidden = !open; });button.setAttribute('aria-expanded',String(open));button.textContent = open ? 'Ver menos' : 'Ver más';
        var parent = list.closest('.collection__filter-collapsible[aria-hidden="false"]');if (parent) parent.style.height = 'auto';
      });
      list.insertAdjacentElement('afterend',button);
    });
  }
  function start() { document.querySelectorAll('[data-section-type="collection"]').forEach(function (section) { initialize(section);new MutationObserver(function () { initialize(section); }).observe(section,{childList:true,subtree:true}); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start);else start();
  document.addEventListener('shopify:section:load',function(e) { initialize(e.target); });
})();



/* WhatsApp B1: número del Liquid, consulta por variante y enlaces de contenido/menú. */
(function () {
  var general = 'Hola, estoy viendo su tienda en línea y quisiera información.';
  function phone() { return document.body.dataset.arolWaNumber.trim(); }
  function href(message) { return 'https://wa.me/' + phone() + '?text=' + encodeURIComponent(message); }
  function decorate(root) {
    var icon = document.querySelector('.arol-wa-line__icon');
    root.querySelectorAll('a[href*="wa.me/"], a[href*="api.whatsapp.com/send"]').forEach(function (a) {
      if (a.hasAttribute('data-arol-wa-product') || a.hasAttribute('data-arol-wa-preserve')) return;
      if (a.classList.contains('arol-wa-line')) return;
      var message = general;
      if (/^\/pages\/contacto\/?$/.test(location.pathname)) message = 'Hola, los contacto desde la página de contacto de su tienda. Quisiera información.';
      if (a.closest('#mini-cart,[data-section-type="cart"]')) message = 'Hola, tengo dudas sobre mi carrito de compras en su tienda en línea.';
      a.href = href(message);
      var text = a.textContent.trim() || 'Escríbenos por WhatsApp';
      a.textContent = '';a.classList.add('arol-wa-line');a.setAttribute('data-arol-wa-general', '');
      if (icon) a.appendChild(icon.cloneNode(true));
      var label = document.createElement('span');label.className = 'arol-wa-line__text';label.textContent = text;a.appendChild(label);
      a.target = '_blank';a.rel = 'noopener';a.setAttribute('aria-label', text + ' (se abre en una pestaña nueva)');
    });
  }
  function start() { decorate(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);else start();
  document.addEventListener('shopify:section:load', function (e) { decorate(e.target); });
  document.addEventListener('variant:changed', function (e) {
    var v = e.detail && e.detail.variant, section = e.target.closest && e.target.closest('[data-section-type="product"]');
    if (!v || !section) return;
    section.querySelectorAll('[data-arol-wa-product]').forEach(function (a) {
      var sku = String(v.sku || '').trim();
      a.href = href(a.dataset.messagePrefix + a.dataset.productTitle + (sku ? '. SKU: ' + sku : '') + ' ' + a.dataset.productUrl + '?variant=' + v.id);
    });
  });
})();

/* WhatsApp de navegación: evita controles/textos de tarjetas y se retira al llegar al pie. */
(function () {
  function start() {
    var button = document.getElementById('whatsapp-floating-btn');
    if (!button || button.dataset.waReady) return;
    button.dataset.waReady = 'true';
    var pending = false;
    function blocked(x, y) {
      return document.elementsFromPoint(x, y).some(function (el) {
        if (el === button || button.contains(el)) return false;
        var anchor = el.closest('a[href]');
        return !!(el.closest('button,input,select,textarea,[role="button"],.arol-card-content,.product-item__info,p,h1,h2,h3,h4,li,dt,dd,label,footer') || (anchor && !anchor.classList.contains('lnk')));
      });
    }
    function check() {
      pending = false;
      button.removeAttribute('data-wa-collision');
      button.style.pointerEvents = 'none';
      var footer = document.querySelector('footer');
      button.toggleAttribute('data-wa-footer', !!footer && footer.getBoundingClientRect().top < innerHeight / 2);
      var clear = false, header = document.querySelector('.shopify-section__header'), limit = header ? header.getBoundingClientRect().bottom : 100;
      for (var lift = 0; lift <= innerHeight - 64 - Math.max(100, limit); lift += 16) {
        button.style.setProperty('--arol-wa-lift', lift + 'px');
        var r = button.getBoundingClientRect();
        if (r.top >= 0 && ![[r.left+4,r.top+4],[r.right-4,r.top+4],[r.left+4,r.bottom-4],[r.right-4,r.bottom-4],[r.left+24,r.top+24]].some(function (p) { return blocked(p[0], p[1]); })) { clear = true;break; }
      }
      if (!clear) button.setAttribute('data-wa-collision', '');
      button.style.pointerEvents = '';
    }
    function schedule() { if (!pending) { pending = true;requestAnimationFrame(check); } }
    window.addEventListener('scroll', schedule, {passive:true});
    window.addEventListener('resize', schedule, {passive:true});
    new MutationObserver(schedule).observe(document.body, {subtree:true,attributes:true,attributeFilter:['aria-hidden','aria-expanded']});
    document.querySelectorAll('.product-list').forEach(function (list) {
      new MutationObserver(schedule).observe(list, {subtree:true,childList:true,attributes:true,attributeFilter:['class']});
    });
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);else start();
  document.addEventListener('shopify:section:load', start);
})();

/* Ficha color: conserva MXN pequeño cuando el tema actualiza el precio por variante. */
(function () {
  if (!document.body.classList.contains('template-product')) return;
  function format(root) {
    root.querySelectorAll('.product-form .price-list>.price:not(.price--compare)').forEach(function (price) {
      if (price.querySelector('.arol-price-currency')) return;
      Array.from(price.childNodes).forEach(function (node) {
        if (node.nodeType !== 3 || !node.textContent.includes('MXN')) return;
        var parts = node.textContent.split('MXN'), currency = document.createElement('span');
        currency.className = 'arol-price-currency';currency.textContent = 'MXN';
        node.replaceWith(document.createTextNode(parts[0]), currency, document.createTextNode(parts.slice(1).join('MXN')));
      });
    });
  }
  function start() {
    format(document);
    document.querySelectorAll('.product-form .price-list').forEach(function (prices) {
      new MutationObserver(function () { format(prices.parentElement); }).observe(prices, {childList:true,subtree:true});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);else start();
})();

/* Ficha móvil grande: controles nativos de galería y nodos de precio/SKU, reversibles. */
(function () {
  if (!document.body.classList.contains('template-product')) return;
  var media = matchMedia('(max-width:640px)'), state;
  function shorten(s) {
    if (!s || !media.matches) return;
    var title = s.title, probe = title.cloneNode(false), words = s.fullTitle.split(/\s+/), n = words.length;
    probe.removeAttribute('id');probe.setAttribute('aria-hidden', 'true');
    probe.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;width:' + title.clientWidth + 'px;height:auto;max-height:none;display:block;margin:0';
    title.parentElement.appendChild(probe);probe.textContent = s.fullTitle;
    var maxHeight = parseFloat(getComputedStyle(probe).lineHeight) * 2 + 1;
    while (probe.getBoundingClientRect().height > maxHeight && n > 1) probe.textContent = words.slice(0, --n).join(' ') + '…';
    title.textContent = probe.textContent;probe.remove();
  }
  function enable() {
    if (state) { shorten(state);return; }
    var section = document.querySelector('[data-section-type="product"]');
    if (!section) return;
    var info = section.querySelector('.product-block-list__item--info'), form = info && info.querySelector('.product-form'), gallery = section.querySelector('.product-gallery');
    if (!form || !gallery) return;
    var title = info.querySelector('.product-meta__title'), summary = document.createElement('div');
    summary.className = 'arol-mobile-summary';form.prepend(summary);
    state = {title:title,fullTitle:title.textContent.trim(),titleAttr:title.getAttribute('title'),aria:title.getAttribute('aria-label'),summary:summary,moved:[]};
    title.title = state.fullTitle;title.setAttribute('aria-label', state.fullTitle);
    var menu = document.querySelector('#mobile-menu .mobile-menu__nav');
    if (menu && !menu.querySelector('a[href="/search"]')) {
      var search = document.createElement('li'), link = document.createElement('a');
      link.className='mobile-menu__nav-link arol-mobile-search-link';link.href='/search';link.textContent='Buscar productos';search.appendChild(link);menu.prepend(search);state.search=search;
    }
    var price = info.querySelector('.arol-shipping-quote-price .price-list') || info.querySelector('.product-form__info-list:not([hidden]) .price-list') || info.querySelector('.arol-quote h2');
    [price, info.querySelector('[data-arol-sku-control]')].forEach(function (node) {
      if (!node) return;
      var placeholder = document.createComment('AROL ubicación escritorio');node.before(placeholder);
      state.moved.push({node:node,placeholder:placeholder});summary.appendChild(node);
    });
    var carousel = gallery.querySelector('.product-gallery__carousel'), wrapper = gallery.querySelector('.product-gallery__carousel-wrapper');
    var counter = document.createElement('span'), dots = document.createElement('div');
    counter.className = 'arol-gallery-counter';counter.setAttribute('role', 'status');counter.setAttribute('aria-live', 'polite');
    dots.className = 'arol-gallery-dots';dots.setAttribute('role', 'group');dots.setAttribute('aria-label', 'Galería del producto');
    wrapper.appendChild(counter);wrapper.after(dots);state.counter=counter;state.dots=dots;
    var signature = '';
    function update() {
      var cells = Array.from(carousel.querySelectorAll('.product-gallery__carousel-item:not(.is-filtered)'));
      var key = cells.map(function (c) { return c.dataset.mediaId; }).join(',');
      if (key !== signature) {
        signature = key;dots.textContent = '';
        cells.forEach(function (cell, i) {
          var dot = document.createElement('button'), type = cell.dataset.mediaType;
          dot.type = 'button';dot.className = 'arol-gallery-dot';
          dot.setAttribute('aria-label', 'Mostrar ' + (type.indexOf('video') >= 0 ? 'video' : type === 'model' ? 'modelo 3D' : 'foto') + ' ' + (i+1) + ' de ' + cells.length);
          dot.addEventListener('click', function () {
            var thumb = gallery.querySelector('.product-gallery__thumbnail[data-media-id="' + cell.dataset.mediaId + '"]');
            if (thumb) thumb.click();
          });dots.appendChild(dot);
        });
      }
      var selected = Math.max(0, cells.findIndex(function (c) { return c.classList.contains('is-selected'); }));
      counter.textContent = (selected+1) + '/' + cells.length;
      Array.from(dots.children).forEach(function (dot, i) { dot.setAttribute('aria-pressed', String(i === selected)); });
    }
    state.observer = new MutationObserver(update);state.observer.observe(carousel, {subtree:true,attributes:true,attributeFilter:['class']});update();shorten(state);
    document.fonts.ready.then(function () { shorten(state); });
  }
  function disable() {
    if (!state) return;
    state.observer.disconnect();state.counter.remove();state.dots.remove();if(state.search)state.search.remove();
    state.moved.forEach(function (entry) { entry.placeholder.replaceWith(entry.node); });state.summary.remove();
    state.title.textContent = state.fullTitle;
    ['title','aria-label'].forEach(function (attr,i) { var value=i ? state.aria : state.titleAttr;if(value===null)state.title.removeAttribute(attr);else state.title.setAttribute(attr,value); });
    state = null;
  }
  function refresh() { if(media.matches)enable();else disable(); }
  if (document.readyState==='loading')document.addEventListener('DOMContentLoaded',refresh);else refresh();
  media.addEventListener('change',refresh);
  window.addEventListener('resize',function(){if(state)requestAnimationFrame(function(){shorten(state);});},{passive:true});
})();

/* Mínimo de refacciones: estado Liquid renovado por el carrito nativo, sin leer metafields desde Ajax. */
(function () {
  var scope = '#mini-cart,[data-section-type="cart"]', observed = new WeakSet();
  function blocked(root) {
    return !!root.querySelector('[data-arol-cart-minimum][data-blocked="true"]');
  }
  function sync(root) {
    if (!blocked(root)) return; // Un nuevo HTML de Shopify restituye sus controles normales.
    root.querySelectorAll('[name="checkout"]').forEach(function (button) {
      button.disabled = true;button.setAttribute('aria-disabled', 'true');
    });
    root.querySelectorAll('.additional-checkout-buttons,.dynamic-checkout__content,.shopify-payment-button,[data-shopify="payment-button"]').forEach(function (box) {
      box.hidden = true;
    });
  }
  function start() {
    document.querySelectorAll(scope).forEach(function (root) {
      sync(root);
      if (observed.has(root)) return;
      observed.add(root);
      new MutationObserver(function () { sync(root); }).observe(root, {childList:true,subtree:true});
    });
  }
  document.addEventListener('submit', function (event) {
    var root = event.target.closest(scope);
    // En carrito solo se envía checkout; otras acciones de cantidad/notas son Ajax.
    if (root && event.target.matches('#mini-cart,.cart-recap') && blocked(root)) { event.preventDefault();event.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('click', function (event) {
    var control = event.target.closest('[name="checkout"],a[href^="/checkout"],.additional-checkout-buttons,.dynamic-checkout__content,.shopify-payment-button,[data-shopify="payment-button"]');
    var root = control && control.closest(scope);
    if (root && blocked(root)) { event.preventDefault();event.stopImmediatePropagation(); }
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);else start();
  document.addEventListener('shopify:section:load', start);
})();
